export { Body } from './body';
export { BodyHeading } from './body-heading';
export { BodyContent } from './body-content';
export type { BodyProps } from './body';
